import { Environment } from './Environment'
import type { MonitoringClient } from './MonitoringClient'

export interface MonitoringConfig {
  endpoint?: string
  maxBatchSize?: number
  flushInterval?: number
  maxPayloadSize?: number
}

export class FactoryMonitoringClient {
  static create(config: MonitoringConfig = {}) {
    return new FactoryMonitoringClient(config)
  }

  constructor(private config: MonitoringConfig) {}

  async client(): Promise<MonitoringClient> {
    const isNode = Environment.create().isNode()

    return isNode
      ? (await import('../clients/NodeMonitoringClient')).NodeMonitoringClient.create()
      : (await import('../clients/BrowserMonitoringClient')).BrowserMonitoringClient.create(
          this.config
        )
  }
}
